import ImageSizeOverridePolicy from './policies/ImageSizeOverridePolicy';

export interface AssetSizeOverridable {
  overrideDefaultSelection(): boolean;
  offerSize(): string;
}

class ImageSizeOverride implements AssetSizeOverridable {
  readonly #policy: ImageSizeOverridePolicy;
  readonly defaultSize: string = 'Medium';
  constructor(policy: ImageSizeOverridePolicy) {
    this.#policy = policy;
  }

  overrideDefaultSelection(): boolean {
    return this.#policy.overrideDefaultSelection(this.defaultSize);
  }

  offerSize(): string {
    return this.defaultSize;
  }
}

export default ImageSizeOverride;
